/** A flow-only command targets the athlete whose Behavior is currently executing. */
export function athleteCounterContext(data: {
  athlete?: unknown;
  group?: unknown;
}) {
  const athlete = data.athlete as
    | { id?: unknown; groupId?: unknown }
    | undefined;
  const group = data.group as { id?: unknown } | undefined;
  return {
    athleteId: String(athlete?.id ?? "").trim(),
    groupId: String(athlete?.groupId ?? group?.id ?? "").trim(),
  };
}
